// SpiritPage.js (updated again with state passing)
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faHome, faSearch, faBookmark, faCog, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import Header from './components/Header';

const INGREDIENT_IMAGE_BASE_URL = '/img/ingredients/';

function SpiritPage({ userData, apiClient, onLogout }) {
  const navigate = useNavigate();
  const [spirits, setSpirits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSpirits = async () => {
      try {
        const data = await apiClient.request('/api/spirits', {
          method: 'POST',
          body: JSON.stringify({ userid: userData.userid }),
        });
        setSpirits(data.spirits || []);
      } catch (err) {
        setError(err.message || 'Failed to fetch spirits');
        if (err.message === 'Failed to refresh token') {
          onLogout();
          navigate('/');
        }
      } finally {
        setLoading(false);
      }
    };

    if (userData && userData.userid && userData.access_token) {
      fetchSpirits();
    } else {
      setError('User data is incomplete');
      setLoading(false);
    }
  }, [userData, apiClient, onLogout, navigate]);

  const handleSpiritClick = (typeid, spiritName) => {
    navigate(`/cocktails/type/${typeid}`, { state: { spiritName } });
  };

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  if (error) {
    return <div className="text-red-500 text-center">{error}</div>;
  }

  return (
    <div className="cocktails-container">
      {/* Top gradient section */}
      <div className="cocktails-gradient-bg"></div>

      {/* Content container */}
      <div className="cocktails-content-container">
        <Header
          showBack={true}
          title="By Spirit"
          subtitle="Find cocktails by base spirit"
          showProfile={true}
          onLogout={onLogout}
          onBack={() => navigate(-1)}
        />

        {/* Search */}
        <div className="search-bar">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input type="text" placeholder="Search cocktails" className="search-input" />
          <button className="filter-btn">
            <FontAwesomeIcon icon={faSlidersH} />
          </button>
        </div>

        {/* Spirit Grid */}
        <div className="spirit-grid">
          {spirits.map((spirit) => (
            <div
              key={spirit.typeid}
              className="spirit-card"
              onClick={() => handleSpiritClick(spirit.typeid, spirit.name)} // Pass both typeid and name
              style={{ cursor: 'pointer' }}
            >
              <img src={`${INGREDIENT_IMAGE_BASE_URL}${spirit.image}`} alt={spirit.name} />
              <div className="spirit-card-overlay"></div>
              <div className="spirit-card-content">
                <h3 className="text-xl font-bold mb-1">{spirit.name}</h3>
                <p className="text-gray-300 text-sm">{spirit.recipe_count} recipes</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SpiritPage;